/* tslint:disable */

/**
 */
export class EquipmentFamily {
    ID_FAMILY?: number;
    BATCH_PROCESS?: number;
    TYPE_CELL?: number;
    CODE_LANGUE?: number;
    ID_TRANSLATION?: number;
    LABEL?: string;
    TRANS_TYPE?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/equipment-family.ts